// extracted by css-extract-rspack-plugin
var _1 = "src-components-RightBar-MessageList-MessageGroup-MessageGroup-module__animatedGroup-EXnzsF";
var _2 = "src-components-RightBar-MessageList-MessageGroup-MessageGroup-module__messageGroup-qP4Xn8";
var _3 = "src-components-RightBar-MessageList-MessageGroup-MessageGroup-module__messageGroupHeader-V25xtr";
export { _1 as "animatedGroup", _2 as "messageGroup", _3 as "messageGroupHeader" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"animatedGroup\":\"src-components-RightBar-MessageList-MessageGroup-MessageGroup-module__animatedGroup-EXnzsF\",\"messageGroup\":\"src-components-RightBar-MessageList-MessageGroup-MessageGroup-module__messageGroup-qP4Xn8\",\"messageGroupHeader\":\"src-components-RightBar-MessageList-MessageGroup-MessageGroup-module__messageGroupHeader-V25xtr\"}";
        // 1752373455126
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  